






















import AppSubTitle from "../atoms/AppSubTitle.vue";
import StepItem from "../molecules/StepItem.vue";
import AddIcon from "../../assets/icons/Orion_add-circle.svg";
import { Step } from "../../components/molecules/StepItem.vue";
import Vue, { PropType } from "vue";
type Data = {
  stepItems: Step[];
  isEdit: boolean;
};

export default Vue.extend({
  components: {
    AppSubTitle,
    StepItem,
    AddIcon
  },
  props: {
    steps: {
      type: Array as PropType<Step[]>,
      default: () => []
    }
  },
  data(): Data {
    return {
      stepItems: this.steps,
      isEdit: true
    };
  },
  methods: {
    isLast(index: number): boolean {
      return this.steps.length - 1 === index;
    },
    toggleEdit() {
      this.isEdit = !this.isEdit;
    },
    onChangeStepList(stepItem: Step, index: number): void {
      this.stepItems[index] = stepItem;
      this.$emit("on-change-step-list", this.stepItems);
    },
    upListItem(index: number): void {
      this.$emit("on-up-list", {
        item: "steps",
        index: index
      });
    },
    downListItem(index: number): void {
      this.$emit("on-down-list", {
        item: "steps",
        index: index
      });
    },
    deleteListItem(index: number): void {
      this.$emit("delete-list-item", { item: "steps", index: index });
    },
    addListItem(): void {
      this.$emit("add-list-item", { item: "steps" });
    }
  }
});
